/**
 * Static MVP copy for the Home composer's rotating starter-question chip, per the
 * finalized copy sheet ("Frontier UX - Static Copy - Home - Intro"). Order matches the sheet.
 * Hardcoded, not fetched — if Product updates the copy sheet, they need to let engineering
 * know so this array gets updated too.
 */
export const HOME_STARTER_QUESTIONS: ReadonlyArray<string> = [
  'Which vehicles are most affordable?',
  'Show me new arrivals',
  'What are the options with lowest mileage?',
  'Help me find the right car',
  'What vehicles are popular right now?',
  'How much can I get for my trade-in?',
  'How can I get pre-qualified?',
  'Walk me through how Carvana works'
];
